/**
 * File type values used by VersionEntry.fixedInfo field.
 */
var VersionFileType;
(function (VersionFileType) {
    VersionFileType[VersionFileType["Unknown"] = 0] = "Unknown";
    VersionFileType[VersionFileType["App"] = 1] = "App";
    VersionFileType[VersionFileType["DLL"] = 2] = "DLL";
    VersionFileType[VersionFileType["Driver"] = 3] = "Driver";
    VersionFileType[VersionFileType["Font"] = 4] = "Font";
    VersionFileType[VersionFileType["VxD"] = 5] = "VxD";
    VersionFileType[VersionFileType["StaticLibrary"] = 7] = "StaticLibrary";
})(VersionFileType || (VersionFileType = {}));
export default VersionFileType;
